/**
 * API client for the validate-only "Add Program" panel (admin backend, Item C).
 *
 * POSTs a ProgramSpec YAML to the admin backend, which validates it against the
 * same universal schema the CLI loader uses. Returns {valid: true, summary} on
 * success or {valid: false, stage, errors} on failure — the backend uses HTTP
 * 400 for invalid input, so we read the JSON body regardless of status.
 */

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8001';

export async function validateProgram(yamlText) {
  const res = await fetch(`${API_URL}/api/admin/programs/validate`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ yaml: yamlText }),
  });
  return res.json();
}

// Dry-run DIFF against the currently-selected institution (X-Institution-Id is
// added by the global institutionFetch interceptor). Read-only — reports what a
// load WOULD change; never writes. Returns {valid, program, course_preflight,
// plan} or {valid:false, stage, errors} (read regardless of HTTP status).
export async function dryRunProgram(yamlText, { force = false, allowMissingCourses = false } = {}) {
  const res = await fetch(`${API_URL}/api/admin/programs/dry-run`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ yaml: yamlText, force, allow_missing_courses: allowMissingCourses }),
  });
  return res.json();
}

// Commit (WRITE) the program to the selected institution's catalog. Always sends
// confirm:true (explicit intent); a force/replace also sends confirmProgramName,
// which the backend requires to match the program name exactly. Returns the plan
// plus {loaded, reason?}.
export async function commitProgram(
  yamlText,
  { force = false, allowMissingCourses = false, confirmProgramName = null } = {},
) {
  const res = await fetch(`${API_URL}/api/admin/programs/commit`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      yaml: yamlText,
      force,
      allow_missing_courses: allowMissingCourses,
      confirm: true,
      confirm_program_name: confirmProgramName,
    }),
  });
  return res.json();
}
